import { useMemo } from 'react'

import { type Option } from 'core/domain/Option'

import type { Shipment } from '../../domain/Shipment'
import { formatStopName } from '../../presenters/shipmentChargePresenter'

export const noStopOption = {
  value: 'not-applicable',
  label: 'Not Applicable',
}

export function useShipmentChargeStopOptions({ shipment }: { shipment: Shipment }) {
  const stopOptions: Array<Option<string | number>> = useMemo(() => {
    return [
      noStopOption,
      ...shipment.stops.map(stop => ({
        label: formatStopName(stop),
        value: stop.stopIndex,
      })),
    ]
  }, [shipment.stops])

  return { stopOptions }
}
